import Vue from 'vue'
import VueRouter from 'vue-router'
import Calendar from './views/Calendar.vue'
import Login from './views/Login.vue'
import store from './store'
import { AdminLevel } from './data'

Vue.use(VueRouter)

const guards = {
  onlyAdmin(to, from, next) {
    if (store.state.user?.admin) {
      next()
    } else {
      next({ name: 'login', params: { nextPage: to.name } })
    }
  },
  onlySuper(to, from, next) {
    if (store.state.user?.admin >= AdminLevel.SUPER) {
      next()
    } else {
      next({ name: 'login', params: { nextPage: to.name } })
    }
  },
  onlyAdminOrSupervisor(to, from, next) {
    const { user } = store.state
    if (user?.admin || user?.role === 'Supervisor') {
      if (user.name !== 'Paul Mann') {
        next()
      }
    } else {
      next({ name: 'login', params: { nextPage: to.name } })
    }
  },
  needsSignedInUser(to, from, next) {
    if (store.state.user?.id) {
      next()
    } else {
      next({ name: 'login', params: { nextPage: to.name } })
    }
  },
  toCalendarIfLoggedIn(to, from, next) {
    if (store.state.user?.id) {
      next({ name: 'calendar' })
    } else {
      next()
    }
  }
}

const routes = [
  {
    path: '/calendar',
    alias: '/',
    name: 'calendar',
    component: Calendar,
    beforeEnter: guards.needsSignedInUser
  },
  {
    path: '/calendar/:userSlug',
    name: 'user-calendar',
    component: Calendar,
    beforeEnter: guards.onlyAdmin,
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: guards.toCalendarIfLoggedIn
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
    beforeEnter: guards.onlyAdmin
  },
  {
    path: '/overview/:startDate?',
    name: 'overview',
    component: () => import(/* webpackChunkName: "overview" */ './views/Overview.vue'),
    beforeEnter: guards.onlyAdmin,
    props: true
  },
  {
    path: '/job/:jobId/load-list',
    name: 'load-list',
    component: () => import(/* webpackChunkName: "jobs" */ './views/LoadList.vue'),
    beforeEnter: guards.needsSignedInUser,
    props: route => ({ jobId: parseInt(route.params.jobId) })
  },
  {
    path: '/jobs/:id?',
    name: 'job-list',
    component: () => import(/* webpackChunkName: "jobs" */ './views/JobList.vue'),
    beforeEnter: guards.needsSignedInUser,
    props: route => ({ editId: route.params.id ? parseInt(route.params.id) : null })
  },
  {
    path: '/job-times',
    name: 'job-times',
    component: () => import(/* webpackChunkName: "jobs" */ './views/JobTimes.vue'),
    beforeEnter: guards.onlyAdmin
  },
  {
    path: '/job-costs',
    name: 'job-costs',
    component: () => import(/* webpackChunkName: "costs" */ './views/JobCosts.vue'),
    beforeEnter: guards.onlyAdminOrSupervisor
  },
  {
    path: '/staff-payroll',
    name: 'staff-payroll',
    component: () => import(/* webpackChunkName: "staff-ot" */ './views/StaffPayroll.vue'),
    beforeEnter: guards.onlyAdmin
  },
  {
    path: '/freelance-payroll',
    name: 'freelance-payroll',
    component: () => import(/* webpackChunkName: "freelance-invoices" */ './views/FreelancePayroll.vue')
  },
  {
    path: '/analysis',
    name: 'analysis',
    component: () => import(/* webpackChunkName: "analysis" */ './views/Analysis.vue')
  },
  {
    path: '/website/projects/:id?',
    name: 'website-projects',
    component: () => import(/* webpackChunkName: "website-projects" */ './views/WebsiteProjects.vue'),
    beforeEnter: guards.onlyAdmin,
    props: route => ({ editId: route.params.id ? parseInt(route.params.id) : null })
  },
  {
    path: '/website/meta',
    name: 'website-meta',
    component: () => import(/* webpackChunkName: "website-projects" */ './views/WebsiteMeta.vue'),
    beforeEnter: guards.onlyAdmin
  },
  {
    path: '/stock-items',
    name: 'stock-items',
    component: () => import(/* webpackChunkName: "admin" */ './views/StockItems.vue'),
    beforeEnter: guards.onlyAdmin
  },
  {
    path: '/charged-out',
    name: 'charged-out-rates',
    component: () => import(/* webpackChunkName: "admin" */ './views/ChargeOutRates.vue'),
    beforeEnter: guards.onlySuper
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
